/**
 * Animation von Texten
 *
 * Dieses script animiert Texte via CSS und Javascript
 *
 * Events: document.ready
 *
 * @param {string} selectorOuter
 *
 * @return {undefined}
 */
function nc_initTextanimation(selectorOuter, selector) {
    var moduleLogger = LoggerManager.get('text-animation').setPrefix('Selektor: ' + selectorOuter);
    moduleLogger.trace('INIT START');
    $(document).ready(function () {
        nc_textanimation(selectorOuter, selector);
    });
    moduleLogger.info('INIT ENDE');
}


/**
 * @see nc_initTextanimation
 */
function nc_textanimation(selectorOuter, selector) {
    var moduleLogger = LoggerManager.get('text-animation').setPrefix('Selektor: ' + selectorOuter);
    moduleLogger.trace('SCRIPT START');
    if (selectorOuter == ".slider") {
        if (amphiEventHandler.hasEvent('amphiCarousel', 'preTranslate')) {
            amphiEventHandler.amphiCarousel.preTranslate.addAction(function (e) {
                var $element = $(e.target);
               $element.find(selector).css({"visibility": "hidden"}).textillate('start');
            });
        }
    }


    $(selectorOuter).find(selector).each(function (index) {
        $(this).textillate({});
    });
    moduleLogger.info('SCRIPT ENDE');
}